@if (product().bundleType && product().bundleType !== 'open') {
  <ui-product-bundle-list-card
    [product]="product()"
    [productItem]="productItem()"
    [showCheckbox]="false"
    [quantityCounterConfig]="quantityCounterData()"
    [quantityCounterControl]="quantityCounterControl"
    [isQuantityChangeLoading]="isQuantityChangeLoading()"
    [isRemoveLoading]="isRemoveLoading()"
    [readonly]="readonly()"
    (removed)="onRemoveCartItem()"
    [enableProductClickTracking]="false"
  >
  </ui-product-bundle-list-card>
} @else if (product().bundleType === 'open') {
  <ui-configurable-bundle-order-card
    [readonly]="readonly()"
    [isRemoveLoading]="isRemoveLoading()"
    [cartItem]="productItem()"
    (remove)="onRemoveCartItem()"
  ></ui-configurable-bundle-order-card>
} @else {
  <ui-product-line-item
    [productItem]="productItem()"
    [quantityCounterControl]="quantityCounterControl"
    [isQuantityChangeLoading]="isQuantityChangeLoading()"
    [isRemoveLoading]="isRemoveLoading()"
    [readonly]="readonly()"
    [enableProductClickTracking]="false"
    [highlightFreeProduct]="true"
    (removed)="onRemoveCartItem()"
  ></ui-product-line-item>
}
